import React from "react";
import { Card, Table, Dropdown, Form, Badge } from "react-bootstrap";

const EscalationRulesList = ({
  showModal,
  closeModal,
  addRules,
  rules,
  setRules,
}) => {
  const alldummyRules = rules && rules.length > 0 ? rules : [];

  return (
    <>
      <Card style={{ backgroundColor: "rgb(255 255 255)" }}>
        <Card.Header style={{ backgroundColor: "rgb(255 255 255)" }} className="d-flex justify-content-between flex-wrap p-2">
          <h5>Escalation Rules List</h5>

          <div className="d-flex">
            <Dropdown className="me-2">
              <Dropdown.Toggle className=" border" variant="light">Select Priority</Dropdown.Toggle>

              <Dropdown.Menu>
                <Dropdown.Item>Critical</Dropdown.Item>
                <Dropdown.Item>High</Dropdown.Item>
                <Dropdown.Item>Medium</Dropdown.Item>
                <Dropdown.Item>Low</Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>

            <Dropdown>
              <Dropdown.Toggle className="border" variant="light">
                Sort By : Last 7 Days
              </Dropdown.Toggle>

              <Dropdown.Menu>
                <Dropdown.Item>Recently Added</Dropdown.Item>
                <Dropdown.Item>Ascending</Dropdown.Item>
                <Dropdown.Item>Descending</Dropdown.Item>
                <Dropdown.Item>Last Month</Dropdown.Item>
                <Dropdown.Item>Last 7 Days</Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </div>
        </Card.Header>

        <Card.Body className="p-0">
          <Table responsive hover className="mb-0">
            <thead className="table-light">
              <tr>
                <th></th>
                <th>Rule ID</th>
                <th>Trigger Type</th>
                <th>Priority</th>
                <th>Condition</th>
                <th>Escalation Level</th>
                <th>Escalates To</th>
                <th>Time Threshold</th>
                <th>Status</th>
                <th></th>
              </tr>
            </thead>

            <tbody>
              {alldummyRules.map((rule, i) => (
                <tr key={i}>
                  <td>
                    <Form.Check />
                  </td>

                  <td>{rule.id}</td>

                  <td className="fw-semibold">{rule.trigger}</td>

                  <td>{rule.priority}</td>

                  <td>{rule.condition}</td>

                  <td>{rule.level}</td>

                  <td>{rule.escalate}</td>

                  <td>{rule.time}</td>

                  <td>
                    <Badge bg="success">Active</Badge>
                  </td>

                  <td>
                    <Badge
                      bg="light"
                      style={{ border: "1px solid #e83e8c", color: "#e83e8c" }}
                    >
                      {rule.action}
                    </Badge>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </Card.Body>
      </Card>

    
        <style>
  {`
    .form-check-input:checked {
      background-color: #f26522;
      border-color: #f26522;
    }
      .dropdown-item:hover {
  background-color: #f26522;
  color: #fff;
}
  `}
  </style>
    </>
  );
};

export default EscalationRulesList;
